(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ag-core"] && !Shopify.designMode) return;
  try {
    window.AG = window.AG || (function () {
    var toast;
    function ensureToast() {
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'ag-toast';
        toast.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg><span></span>';
        document.body.appendChild(toast);
      }
      return toast;
    }
    function showToast(msg) {
      var t = ensureToast();
      t.querySelector('span').textContent = msg;
      t.classList.add('is-show');
      clearTimeout(t._tt);
      t._tt = setTimeout(function () { t.classList.remove('is-show'); }, 2400);
    }
    function refreshCount() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          // Horizon: el contador real es <cart-icon>, que escucha el evento cart:update.
          // source != 'product-form-component' => fija el total (no suma).
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'ag-core', itemCount: c.item_count } } }));
          // Fallback para otros markups/temas.
          document.querySelectorAll('[data-cart-count], .cart-count, cart-icon-component [data-count], .cart-bubble__text-count').forEach(function (el) { el.textContent = c.item_count; });
          return c;
        });
    }
    function addToCart(variantId, qty) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      }).then(function (res) {
        return refreshCount().then(function () { return res; });
      });
    }
    return { showToast: showToast, addToCart: addToCart, refreshCount: refreshCount };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["calculadora-granel"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-agcalc]').forEach(function (root) {
      var ration = parseInt(root.dataset.ration, 10) || 80;
      var variants = [];
      try { variants = JSON.parse(root.querySelector('[data-agcalc-variants]').textContent); } catch (e) {}
      // gramos a partir del título de la variante
      variants.forEach(function (v) {
        var m = (v.title || '').toLowerCase().match(/([\d.,]+)\s*(kg|g)/);
        v.grams = m ? (parseFloat(m[1].replace(',', '.')) * (m[2] === 'kg' ? 1000 : 1)) : null;
      });
      var withGrams = variants.filter(function (v) { return v.grams && v.available; }).sort(function (a, b) { return a.grams - b.grams; });

      var servings = root.querySelector('[data-agcalc-servings]');
      var gramsEl = root.querySelector('[data-agcalc-grams]');
      var detailEl = root.querySelector('[data-agcalc-detail]');
      var formatEl = root.querySelector('[data-agcalc-format]');
      var priceEl = root.querySelector('[data-agcalc-price]');
      var addBtn = root.querySelector('[data-agcalc-add]');

      function update() {
        var s = Math.max(1, parseInt(servings.value, 10) || 1);
        var needed = ration * s;
        gramsEl.textContent = needed + ' g';
        detailEl.textContent = ration + ' g por ración · ' + s + (s === 1 ? ' ración' : ' raciones');

        var pick = withGrams.find(function (v) { return v.grams >= needed; }) || withGrams[withGrams.length - 1];
        if (pick) {
          formatEl.innerHTML = 'Te sugerimos: <b>' + pick.title + '</b>';
          priceEl.textContent = pick.money;
          addBtn.hidden = false;
          addBtn.textContent = 'Añadir ' + pick.title;
          addBtn.dataset.variant = pick.id;
          addBtn.dataset.name = pick.title;
        } else {
          formatEl.textContent = '';
          priceEl.textContent = '';
          addBtn.hidden = true;
        }
      }

      root.querySelector('[data-agcalc-minus]').addEventListener('click', function () { servings.value = Math.max(1, (parseInt(servings.value, 10) || 1) - 1); update(); });
      root.querySelector('[data-agcalc-plus]').addEventListener('click', function () { servings.value = (parseInt(servings.value, 10) || 1) + 1; update(); });
      servings.addEventListener('input', update);
      addBtn.addEventListener('click', function () {
        AG.addToCart(addBtn.dataset.variant, 1).then(function () { AG.showToast('Añadido · ' + addBtn.dataset.name); }).catch(function () { AG.showToast('No se pudo añadir'); });
      });
      update();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cross-sell-granel"] && !Shopify.designMode) return;
  try {
    (function () {
    /* --- añadir a la cesta (compartido con v1) --- */
    if (!window.__agxBound) {
      window.__agxBound = true;
      document.addEventListener('click', function (e) {
        var one = e.target.closest('[data-agx-add]');
        var all = e.target.closest('[data-agx-all]');
        if (one) {
          e.preventDefault();
          AG.addToCart(one.dataset.agxAdd, 1).then(function () {
            one.classList.add('is-added');
            one.textContent = '\u2713';
            AG.showToast('Añadido: ' + one.dataset.name);
          }).catch(function () { AG.showToast('No se pudo añadir'); });
        }
        if (all) {
          e.preventDefault();
          var ids = all.dataset.agxAll.split(',').filter(Boolean);
          var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (r) { return r.json(); })
            .then(function () { AG.refreshCount(); AG.showToast(ids.length + ' ingredientes añadidos'); })
            .catch(function () { AG.showToast('No se pudo añadir'); });
        }
      });
    }

    /* --- GRAMAJE: escalado de raciones --- */
    function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' \u20ac'; }
    function setupGram(root) {
      var base = parseInt(root.dataset.base, 10) || 2;
      var hasG = root.dataset.hasG === 'true';
      var rac = base;
      var racEl = root.querySelector('[data-gram-rac]');
      var totalEl = root.querySelector('[data-gram-total]');
      var rows = [].slice.call(root.querySelectorAll('.gram-row'));
      function render() {
        if (racEl) racEl.textContent = rac;
        var total = 0;
        rows.forEach(function (row) {
          var g0 = parseFloat(row.dataset.g) || 0;
          var price = parseFloat(row.dataset.price) || 0;   // céntimos
          var unitG = parseFloat(row.dataset.unitG) || 0;   // gramos por el precio
          var gEl = row.querySelector('[data-gram-g]');
          var pEl = row.querySelector('[data-gram-price]');
          if (hasG) {
            var g = Math.round(g0 * rac / base);
            if (gEl) gEl.textContent = g + ' g';
            if (unitG > 0 && price > 0) {
              var c = Math.round(price * g / unitG);
              total += c;
              if (pEl) pEl.textContent = money(c);
            } else { total += price; }
          } else { total += price; }
        });
        if (totalEl) totalEl.textContent = money(total);
      }
      var inc = root.querySelector('[data-gram-inc]');
      var dec = root.querySelector('[data-gram-dec]');
      if (inc) inc.addEventListener('click', function () { rac = Math.min(12, rac + 1); render(); });
      if (dec) dec.addEventListener('click', function () { rac = Math.max(1, rac - 1); render(); });
      render();
    }
    function init() { document.querySelectorAll('[data-gram]').forEach(setupGram); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["exit-popup-granel"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'ag_popup_seen';
    var el = document.querySelector('[data-agpop]');
    if (!el) return;

    var fallback = null;
    function mark() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
    function cleanup() { document.removeEventListener('mouseout', onLeaveWrap); if (fallback) clearTimeout(fallback); }
    function open() { el.hidden = false; requestAnimationFrame(function () { el.classList.add('is-open'); }); mark(); cleanup(); }
    function close() { el.classList.remove('is-open'); setTimeout(function () { el.hidden = true; }, 250); }
    function onLeave(e) { if (e.clientY <= 0) open(); }
    function onLeaveWrap(e) { if (!e.relatedTarget && !e.toElement) onLeave(e); }

    // Cierre (siempre disponible) + Escape
    el.querySelectorAll('[data-agpop-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });

    // 1) Si el formulario se acaba de enviar con éxito, abre para mostrar el mensaje y no reaparece más.
    if (el.querySelector('.agpop__ok')) { open(); return; }

    // 2) No mostrar si ya se vio en los últimos 14 días.
    try {
      var seen = localStorage.getItem(KEY);
      if (seen && (Date.now() - parseInt(seen, 10)) < 14 * 24 * 60 * 60 * 1000) return;
    } catch (e) {}

    // 3) Exit-intent + respaldo a los 25 s.
    fallback = setTimeout(open, 25000);
    document.addEventListener('mouseout', onLeaveWrap);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__agfsBound) return;
    window.__agfsBound = true;

    function formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace(/[^0-9-]/g, '');
      var fmt = format || '{{amount}}';
      function withDelimiters(number, precision, thousands, decimal) {
        precision = precision == null ? 2 : precision;
        thousands = thousands || '.';
        decimal = decimal || ',';
        if (isNaN(number) || number == null) return '0';
        number = (number / 100).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var rest = parts[1] ? decimal + parts[1] : '';
        return dollars + rest;
      }
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      var match = fmt.match(placeholder);
      var name = match ? match[1] : 'amount';
      var value;
      switch (name) {
        case 'amount_no_decimals': value = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
        default: value = withDelimiters(cents, 2, '.', ',');
      }
      return fmt.replace(placeholder, value);
    }

    function render(el, total) {
      var th = parseInt(el.dataset.threshold, 10) || 0;
      var variant = el.dataset.variant || 'header';
      var fmt = el.dataset.moneyFormat;
      var rem = th - total;
      var fill = el.querySelector('[data-agfs-fill]');
      var label = el.querySelector('.agfs__label');
      if (fill) fill.style.width = Math.max(0, Math.min(100, th > 0 ? (total / th * 100) : 0)) + '%';
      if (!label) return;
      if (rem <= 0) {
        el.classList.add('agfs--free');
        label.innerHTML = variant === 'cart'
          ? '¡Genial! Tu pedido tiene <b>envío gratis</b>'
          : '¡Enhorabuena! Tienes <b>envío GRATIS</b>';
      } else {
        el.classList.remove('agfs--free');
        var money = formatMoney(rem, fmt);
        label.innerHTML = variant === 'cart'
          ? 'Añade <b>' + money + '</b> más y el envío es gratis'
          : 'Te faltan <b>' + money + '</b> para el envío GRATIS';
      }
    }

    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-agfs]').forEach(function (el) { render(el, cart.total_price); });
        })
        .catch(function () {});
    }

    // Horizon dispara 'cart:update' al añadir/cambiar el carrito (único evento real)
    document.addEventListener('cart:update', refresh);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-granel"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__agqaBound) return;
    window.__agqaBound = true;

    function closeAll(except) {
      document.querySelectorAll('[data-agqa-pop]').forEach(function (p) {
        if (p !== except) { p.hidden = true; var t = p.parentElement.querySelector('[data-agqa-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); }
      });
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-agqa-toggle]');
      var direct = e.target.closest('[data-agqa-direct]');
      var opt = e.target.closest('[data-agqa-opt], .agqa__opt');
      var confirm = e.target.closest('[data-agqa-confirm]');
      var insidePop = e.target.closest('[data-agqa-pop]');

      if (toggle) {
        e.preventDefault();
        var pop = toggle.parentElement.querySelector('[data-agqa-pop]');
        var willOpen = pop.hidden;
        closeAll(willOpen ? pop : null);
        pop.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', String(willOpen));
        return;
      }

      if (direct) {
        e.preventDefault();
        if (direct.disabled) return;
        AG.addToCart(direct.dataset.agqaVariant, 1).then(function () {
          AG.showToast('Añadido: ' + direct.dataset.name);
        }).catch(function () { AG.showToast('No se pudo añadir'); });
        return;
      }

      if (opt && !opt.classList.contains('is-soldout')) {
        var g = opt.closest('.agqa__opts');
        g.querySelectorAll('.agqa__opt').forEach(function (x) { x.classList.remove('is-active'); });
        opt.classList.add('is-active');
        return;
      }

      if (confirm) {
        e.preventDefault();
        var pop2 = confirm.closest('[data-agqa-pop]');
        var sel = pop2.querySelector('.agqa__opt.is-active');
        if (!sel) return;
        var w = sel.childNodes[0].textContent.trim();
        AG.addToCart(sel.dataset.agqaVariant, 1).then(function () {
          AG.showToast('Añadido: ' + confirm.dataset.name + ' · ' + w);
          closeAll(null);
        }).catch(function () { AG.showToast('No se pudo añadir'); });
        return;
      }

      if (!insidePop) closeAll(null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-granel"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.querySelector('[data-agsticky]');
    if (!bar) return;
    bar.hidden = false;

    var sel = bar.querySelector('[data-agsticky-sel]');
    var priceEl = bar.querySelector('[data-agsticky-price]');
    var addBtn = bar.querySelector('[data-agsticky-add]');

    if (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        addBtn.dataset.variant = sel.value;
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      });
    }

    addBtn.addEventListener('click', function () {
      AG.addToCart(addBtn.dataset.variant, 1).then(function () {
        AG.showToast('Añadido: ' + addBtn.dataset.name + (sel ? ' · ' + sel.options[sel.selectedIndex].text : ''));
      }).catch(function () { AG.showToast('No se pudo añadir'); });
    });

    // Mostrar la barra cuando el botón principal sale de pantalla
    var anchor = document.querySelector('[data-ag-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-visible', !en.isIntersecting); });
      }, { rootMargin: '0px 0px -10px 0px' });
      io.observe(anchor);
    } else {
      // Sin ancla: mostrar tras hacer scroll un poco
      window.addEventListener('scroll', function () {
        bar.classList.toggle('is-visible', window.scrollY > 400);
      }, { passive: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
